import type { WalletProvider } from '@dynamic-labs-sdk/client/core';

import type { BitcoinWalletProvider } from '../BitcoinWalletProvider.types';

export const isBitcoinWalletProvider = (
  provider: WalletProvider
): provider is BitcoinWalletProvider => {
  return provider.chain === 'BTC';
};
